import { render, staticRenderFns } from "./InquiryDetail.vue?vue&type=template&id=0a5ba387&"
import script from "./InquiryDetail.vue?vue&type=script&lang=ts&"
export * from "./InquiryDetail.vue?vue&type=script&lang=ts&"
import style0 from "./InquiryDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports